import { toValue } from "vue";
import { useFetch, useNuxtApp } from "nuxt/app";
export function createUseOpenFetch(client, lazy = false) {
  return (url, options = {}, autoKey) => {
    const nuxtApp = useNuxtApp();
    const $fetch = typeof client === "string" ? nuxtApp[`$${client}`] : client;
    const opts = { $fetch, key: autoKey, ...options };
    return useFetch(() => toValue(url), lazy ? { ...opts, lazy } : opts);
  };
}
